import appActionTypes from '../constants/types'

export const initialState = {
  data: [],
  isLoading: false,
  message: null,
  errorMessage: null,
}

export default (state = initialState, action) => {
  switch (action.type) {
    case appActionTypes.customer_email_domain.get.requested:
    case appActionTypes.customer_email_domain.create.requested:
    case appActionTypes.customer_email_domain.delete.requested:
    case appActionTypes.customer_email_domain.edit.requested:
      return {
        ...state,
        isLoading: true,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.customer_email_domain.get.success:
      return {
        ...state,
        data: action.data,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.customer_email_domain.create.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      _list.push(action.data)
      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.customer_email_domain.delete.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _list.splice(index, 1)

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }

    case appActionTypes.customer_email_domain.edit.success:
      var _list = JSON.parse(JSON.stringify(state.data))
      var index = _list.findIndex((obj) => obj._id === action.data?._id)
      if (index !== -1) _list[index] = action.data

      return {
        ...state,
        data: _list,
        isLoading: false,
        message: action.message,
        errorMessage: null,
      }
    case appActionTypes.customer_email_domain.get.fail:
    case appActionTypes.customer_email_domain.create.fail:
    case appActionTypes.customer_email_domain.delete.fail:
    case appActionTypes.customer_email_domain.edit.fail:
      return {
        ...state,
        isLoading: false,
        message: null,
        errorMessage: action.errorMessage,
      }
    default:
      return state
  }
}
